<template>
    <WebView v-if="cell" :cell="cell"></WebView>
</template>
<script>
    // api
    import {GetNewsDetail} from "../../api/news";
    // js
    import moment from "moment";
    import WebView from "../../components/web-view"

    export default {
        components: {WebView},
        data() {
            return {
                cell: null,
            };
        },
        methods: {
            GetNewsDetail() {
                GetNewsDetail(this.newsId).then((res) => {
                    if (res.status) {
                        let data = res.data;
                        this.cell = {
                            title: data.title,
                            imageUrl: data.imageUrl,
                            content: data.content,
                            createTime: moment(data.publishDate).format("YYYY/MM/DD")
                        }
                    }
                });
            },
        },
        computed: {
            newsId() {
                return this.$route.query.newsId;
            },
        },
        mounted() {
            this.GetNewsDetail();
        },
    };
</script>
<style lang="less" scoped>
</style>
